exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-bot-10 {\n  margin-bottom: 10px;\n}\n\n.margin-top-5 {\n  margin-top: 5px;\n}\n\n.btn-no-skin {\n  padding: 0;\n  border: none;\n  color: black;\n  background-color: transparent;\n}\n\n.btn-no-skin:active {\n  box-shadow: none;\n}\n\n.list-unstyled-questions {\n  list-style: none;\n  padding-left: 10px;\n  margin-top: 5px;\n  margin-bottom: 10px;\n}\n\n.list-unstyled-questions > li > span {\n  margin-left: 5px;\n}\n\n.text-small-indent {\n  margin-left: 12px;\n}\n\n.margin-right-slim {\n  margin-right: 6px;\n}\n\n.form-control.ng-valid[required] {\n  border-left: 5px solid #42A948;\n}\n\n.form-control.ng-invalid.ng-dirty {\n  border-left: 5px solid #a94442;\n}\n\n.markdown-button-position {\n  margin-bottom: 3px;\n}\n\n.markdown-link-position {\n  text-align: center;\n}\n\n.checkbox-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n  gap: 2em;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/dialogs/dialogs-details/dialogs-details.component.css
// module id = ../../../../../src/app/modules/dialogs/dialogs-details/dialogs-details.component.css
// module chunks = main